// extracted by mini-css-extract-plugin
module.exports = {"root":"GamePreview_root_33Uc0","icon":"GamePreview_icon_DqWiP","info":"GamePreview_info_2xjpq"};